<div
  class="vm-tile-container"
  [ngClass]="{
    'tile-active': isChecked
  }"
>
  <div class="tile">
    <div class="tile-icon__container" *ngIf="selectableCard?.icons || selectableCard?.secondaryIcon">
      <ng-container *ngIf="selectableCard?.icons">
        <vm-icon
          ngClass="tile-icon__container--icon"
          [iconAlt]="selectableCard.icons.key"
          [icon]="selectableCard.icons.value"
        >
        </vm-icon>
      </ng-container>

      <ng-container *ngIf="selectableCard?.secondaryIcon">
        <vm-icon
          ngClass="tile-icon__container--icon"
          [iconAlt]="selectableCard.secondaryIcon.key"
          [icon]="selectableCard.secondaryIcon.value"
        >
        </vm-icon>
      </ng-container>
    </div>

    <div class="tile-image__container" *ngIf="areImageAvailable">
      <vm-image
        *ngFor="let image of selectableCard.images"
        [imagePath]="image !== undefined ? image.value : ''"
        [layer]="layer"
        [imageAlt]="image.key"
        [ngClass]="classes"
      >
      </vm-image>
    </div>

    <div class="tile__text-container" vmChallengerDynamicLineHeight [lineHeightLength]="headingMultiLineHeight">
      <div class="tile__heading" [innerHTML]="selectableCard.tileHeading | markdown"></div>
    </div>
    <div *ngIf="selectableCard.linkText" (click)="clickEventPropagation($event)" class="tile__link-container">
      <a class="tile__link" (click)="openModal($event)"> {{ selectableCard.linkText }}</a>
    </div>

    <div class="tile__switch-section" *ngIf="selectableCard.isToggle" (click)="clickEventPropagation($event)">
      <vm-segmented-control
        class="vm-segment_width"
        [primaryColor]="!selectableCard.isPrimaryColorForToggle ? false : selectableCard.isPrimaryColorForToggle"
        [options]="optionsSegment"
        [selectedOption]="selectedToggleOption"
        (optionSelected)="getSelectedToggle($event)"
      >
      </vm-segmented-control>
    </div>

    <div class="tile__switch-section-group" *ngIf="isGroupHavingToggle && !selectableCard.isToggle"></div>

    <p *ngIf="selectableCard.amountAltText; else priceTemplate">{{ selectableCard.amountAltText }}</p>

    <ng-template #priceTemplate>
      <ng-container class="tile__text" *ngIf="chargesTextVisibility">
        <span class="tile__text--light">{{ selectableCard.charges }}</span>
      </ng-container>
      <p class="tile__text" *ngIf="selectableCard.icons || areImageAvailable">
        <span
          class="tile__text--green"
          *ngIf="isChecked && !selectableCard.amount && !selectableCard.isToggle && includedTextVisibility"
        >
          Included
        </span>
        <span class="tile__text--light" *ngIf="!includedTextVisibility">{{ selectableCard.charges }}</span>
        <span
          *ngIf="selectableCard.amount && !selectableCard.isToggle"
          [ngClass]="{ 'solid-title-heading': selectableCard.secondaryIcon }"
          class="tile__text--price"
        >
          <span *ngIf="selectableCard.isAddon">+</span>
          <span class="tile__text--price" [ngClass]="{ 'tile__text--erase-amount': selectableCard.discountAmount }">{{
            selectableCard.amount | vmSalesCurrency: 'GBP':'symbol':'1.0-2'
          }}</span>
          <span *ngIf="selectableCard.discountAmount" class="tile__text--price">{{
            +selectableCard.amount - +selectableCard.discountAmount | vmSalesCurrency: 'GBP':'symbol':'1.0-2'
          }}</span>
          <span class="tile__text--light">/m</span>
          <ng-container *ngIf="selectableCard?.amountLegalSign"
            ><span [innerHTML]="selectableCard?.amountLegalSign"></span
          ></ng-container>
        </span>
        <span *ngIf="toggleAmount && selectableCard.isToggle" class="tile__text--price">
          <span *ngIf="selectableCard.isAddon">+</span>
          <span class="tile__text--price" [ngClass]="{ 'tile__text--erase-amount': toggleDiscountAmount > 0 }">{{
            toggleAmount | vmSalesCurrency: 'GBP':'symbol':'1.0-2'
          }}</span>
          <span *ngIf="toggleDiscountAmount > 0" class="tile__text--price"
            >+{{ toggleAmount - toggleDiscountAmount | vmSalesCurrency: 'GBP':'symbol':'1.0-2' }}</span
          >
          <span *ngIf="selectableCard.secondaryIcon; else defaultPerMonth" class="tile__text--light">/m*</span>

          <ng-template #defaultPerMonth>
            <span class="tile__text--light">/m</span>
            <ng-container *ngIf="selectableCard?.amountLegalSign"
              ><span [innerHTML]="selectableCard?.amountLegalSign"></span
            ></ng-container>
          </ng-template>
        </span>
      </p>
    </ng-template>

    <div class="tile__radio-container" *ngIf="isRadioButtonAvailable">
      <vm-input-radio
        class="tile__btn"
        [productId]="selectableCard.productId"
        [isChecked]="isChecked"
        [alt]="selectableCard.tileHeading"
      >
      </vm-input-radio>
    </div>

    <div class="tile__checkbox-container" *ngIf="isCheckboxButtonAvailable">
      <vm-input-checkbox
        #checkboxElement
        [isChecked]="isChecked"
        [productId]="selectableCard.productId"
        [alt]="selectableCard.tileHeading"
        class="tile__btn-checkbox"
        (click)="checkboxClickEventPropagation($event)"
      ></vm-input-checkbox>
    </div>
  </div>
</div>
<vm-modal
  *ngIf="isModalOpen"
  class="modal-z-index"
  [title]="selectableCard.modalTitle"
  [hideHeader]="false"
  [modalType]="'large'"
  [includeOkButton]="isModalButtonRequired()"
  [includeSecondaryCloseButton]="!isChecked ? false : includeSecondaryCloseButton"
  [okButtonText]="selectableCard.modalButtonText"
  [includeBackground]="true"
  [showFooterBorder]="true"
  (okButtonClick)="closeOkay($event)"
  (closeButtonClick)="closeModal($event)"
  (click)="clickEventPropagation($event)"
>
  <div class="modal-image__container" *ngIf="selectableCard.serviceCategory === 'TV' && selectableCard.modalImages">
    <vm-image
      *ngFor="let image of selectableCard.modalImages"
      [imagePath]="image.value"
      [imageAlt]="image.key"
      [layer]="'modal'"
      [preventOverflow]="true"
      class="modal-image__container--channel"
    >
    </vm-image>
  </div>
  <div class="modal-description" *ngIf="selectableCard.linkText" [innerHTML]="selectableCard.modalDescription"></div>
</vm-modal>
